import { render } from "./Events.vue?vue&type=template&id=778a02dc&scoped=true"
import script from "./Events.vue?vue&type=script&lang=js"
export * from "./Events.vue?vue&type=script&lang=js"

import "./Events.vue?vue&type=style&index=0&id=778a02dc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-778a02dc"

export default script